import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ApiService } from './services/api/api.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    title = 'LionsgateSphere-fe';
    isMobile: boolean = false

    constructor(
        public apiService: ApiService,
        private breakpointObserver: BreakpointObserver,
        private router: Router,
    ) {
        // Every navigation should start at the top of the page. Angular's
        // scrollPositionRestoration only touches the window/documentElement,
        // but on mobile `body` itself is the scroll container
        // (styles.scss: body { overflow-y: scroll }), so reset all of them.
        this.router.events
            .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
            .subscribe(() => this.scrollToTop());

        // this.apiService.getApiData1()

        // this.apiService.loadXML('assets/json/MOVSP.xml')
        breakpointObserver.observe([
            Breakpoints.HandsetLandscape,
            Breakpoints.HandsetPortrait
        ]).subscribe(result => {
            if (result.matches) {
                this.isMobile = true;
            }
            else {
                this.isMobile = false;
            }
        });
    }

    private scrollToTop(): void {
        const reset = () => {
            window.scrollTo(0, 0);
            if (document.scrollingElement) {
                document.scrollingElement.scrollTop = 0;
            }
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
        };
        reset();
        // Run again after the new view / route animation has settled.
        requestAnimationFrame(reset);
    }
}
